import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Notifier extends Component {
  constructor() {
    super();
    this.state = {
      closed: false
    };
  }

  onClickOfClose(e) {
    e.preventDefault();
    this.setState({closed: true});
  }

  render() {
    const {
      status,
      hasClose,
      children
    } = this.props;

    return !this.state.closed && (
      <div className={`alert alert-${status}`}>
        <span>{children}</span>
        {hasClose && (
          <a href="#" onClick={this.onClickOfClose.bind(this)} className={'close'} title={'close notifier'}>×</a>
        )}
      </div>
    );
  }
}

Notifier.defaultProps = {
  status: 'info'
};

Notifier.propTypes = {
  status: PropTypes.string.isRequired,
  hasClose: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default Notifier;
